var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F8F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.875 35.25C47.9261 35.25 41.4375 41.7386 41.4375 49.6875C41.4375 54.6581 43.9744 59.076 47.8189 61.6768C40.4619 64.8324 35.25 72.1275 35.25 80.625H39.375C39.375 71.4881 46.7381 64.125 55.875 64.125C58.713 64.125 61.3489 64.8634 63.6713 66.1256C61.2953 69.0612 59.9993 72.7234 60 76.5C60 85.5874 67.4126 93 76.5 93C85.5874 93 93 85.5874 93 76.5C93 67.4126 85.5874 60 76.5 60C73.0247 60.0047 69.64 61.1093 66.831 63.1556C65.9194 62.5843 64.9335 62.1038 63.9311 61.6748C65.8941 60.3509 67.5023 58.5658 68.6148 56.4759C69.7274 54.386 70.3103 52.0551 70.3125 49.6875C70.3125 41.7386 63.8239 35.25 55.875 35.25ZM55.875 39.375C61.5943 39.375 66.1875 43.9682 66.1875 49.6875C66.1875 55.4068 61.5943 60 55.875 60C50.1557 60 45.5625 55.4068 45.5625 49.6875C45.5625 43.9682 50.1557 39.375 55.875 39.375ZM76.5 64.125C83.3599 64.125 88.875 69.6401 88.875 76.5C88.875 83.3599 83.3599 88.875 76.5 88.875C69.6401 88.875 64.125 83.3599 64.125 76.5C64.125 69.6401 69.6401 64.125 76.5 64.125ZM74.4375 68.25V74.4375H68.25V78.5625H74.4375V84.75H78.5625V78.5625H84.75V74.4375H78.5625V68.25H74.4375Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserIcon);
export default __webpack_public_path__ + "static/media/no-user-icon.dd2f2cc00bb9e5e5787932652c7e1351.svg";
export { ForwardRef as ReactComponent };